import React, { createContext, useEffect, useState } from 'react';

export const LangContext = createContext();

export const LangProvider = ({ children }) => {  
  const [selectLanguage, setSelectLanguage] = useState('');  

  useEffect(() => {
    async function fetchUserCountry() {
      try {
        const response = await Promise.race([
          fetch('https://geolocation-db.com/json/'),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Request timed out')), 1000))
        ]);
        const data = await response.json();
        const ipv4 = data.IPv4;
  
        const response2 = await Promise.race([
          fetch(`https://web3.metatoydragonz.io/ipchk?query=${ipv4}`),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Request timed out')), 1000))
        ]);
        const data2 = await response2.json();
        const country = data2.response.whois.countryCode;
  
        if (country === 'KR') {
          setSelectLanguage('한국어');
        } else {
          setSelectLanguage('ENGLISH');
        }
      } catch (error) {
        setSelectLanguage('ENGLISH');
        console.error('나라 확인에 실패했습니다:', error);
      }
    }
  
    fetchUserCountry();
  }, []);
  /*
  useEffect(() => {
    async function fetchUserCountry() {
      try {
        const response = await fetch('https://geolocation-db.com/json/');
        const data = await response.json();
        const ipv4 = data.IPv4;f

        //const response2 = await fetch('https://web3dev-api.meta-toy.world/ipchk?query='+ipv4);
        const response2 = await fetch('https://web3.metatoydragonz.io/ipchk?query='+ipv4);
        const data2 = await response2.json();
        const country = data2.response.whois.countryCode;

        if(country === 'KR'){
          setSelectLanguage('한국어');
        }else{
          setSelectLanguage('ENGLISH');
        }
        return country;
        
      } catch (error) {
        setSelectLanguage('ENGLISH');
        console.error('나라 확인에 실패했습니다:', error);
      }
    }
    fetchUserCountry();    
  },[])
  */

  return (
    <LangContext.Provider value={{ selectLanguage, setSelectLanguage }}>
      {selectLanguage && children}
    </LangContext.Provider>
  );
};
